import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { PlaylistProps } from "./types";
import {
  PropertyDefinition,
  PropertyMappingType,
} from "app/library/layout-builder";

export class PlaylistDefinitions extends CmsReactComponent<PlaylistProps> {

  static schemaName = "playlist";

  static propertyDefinitions: PropertyDefinition[] = [
    {
      name: "data",
      mapping: {
        type: PropertyMappingType.ArrayData,
        keys: [
          {
            name: "title",
            mapping: {
              type: PropertyMappingType.String
            },
            text: "Başlık"
          },
          {
            name: "audio",
            mapping: {
              type: PropertyMappingType.File
            },
            text: "Ses"
          },
          {
            name: "content",
            mapping: {
              type: PropertyMappingType.Html
            },
            text: "İçerik"
          },
        ]
      },
      text: "İçerikler",
    }
  ];
}
